import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters.js'
// import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const modulesFiles = import.meta.globEager('./modules/*.js')

const modules = Object.keys(modulesFiles).reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/modules\/(.*)\.\w+$/, '$1')
  const value = modulesFiles[modulePath]
  modules[moduleName] = value.default
  return modules
}, {})

const store = new Vuex.Store({
  modules,
  getters,
  // plugins: [createPersistedState()],
})

export default store
